import { Avatar } from '@library/components/avatar/Avatar';
import { Menu } from '@headlessui/react';
import { UserMenuItem } from '@library/components/menus';

export interface UserMenuProps {
  disabled?: boolean;
  firstName?: string;
  lastName?: string;
  googleAvatarUrl?: string;
  handleOnLogoutClick: () => void;
}

export const UserMenu = ({
  disabled = false,
  firstName = undefined,
  lastName = undefined,
  googleAvatarUrl = undefined,
  handleOnLogoutClick
}: UserMenuProps) => {
  const messageString = disabled ? 'Logging out...' : 'Logout';
  return (
    <Menu>
      {() => {
        return (
          <>
            <Menu.Button
              type="button"
              title="UseMenuButton"
              data-testid="user-menu-button"
            >
              <div className="float-right inline-flex items-center justify-end">
                <Avatar className="size-4" googleAvatarUrl={googleAvatarUrl} />
                <span className="pl-2 text-xs">
                  {firstName} {lastName}
                </span>
              </div>
            </Menu.Button>
            <Menu.Items className="bg-soFresh-140 divide-soFresh-140 absolute bottom-16 right-4 rounded-lg shadow-lg">
              <div className="w-45 py-2">
                <UserMenuItem
                  disabled={disabled}
                  handleOnClick={handleOnLogoutClick}
                  message={messageString}
                />
              </div>
            </Menu.Items>
          </>
        );
      }}
    </Menu>
  );
};
